import React, { useState } from "react";
import { Link } from "react-router-dom";
import styles from "./Contact.module.css";
import homeStyles from "./Home.module.css";

export default function Contact() {
  const [menuOpen, setMenuOpen] = useState(false);
  const handleMenuClose = () => setMenuOpen(false);

  return (
    <div className={homeStyles.root}>
      {/* HEADER (navbar) */}
      <header className={homeStyles.header}>
        <Link to="/">
          <img src="/logo2.png" className={homeStyles.logo} alt="Paperly logo" />
        </Link>
        <nav className={homeStyles.navBar}>
          <div className={homeStyles.navLinks}>
            {/* <a href="/o-nas" className={homeStyles.navLink}>O nas</a>
            <a href="/uslugi" className={homeStyles.navLink}>Usługi</a>
            <a href="/case-study" className={homeStyles.navLink}>Case Study</a>
            <a href="/webinary" className={homeStyles.navLink}>Webinary</a>
            <a href="/baza-wiedzy" className={homeStyles.navLink}>Baza wiedzy</a> */}
          </div>
          <a href="/kontakt" className={homeStyles.ctaBtn}>Bezpłatna konsultacja</a>
          <a href="/login" className={homeStyles.ctaBtn}>Zaloguj</a>
        </nav>
        {/* Hamburger icon for mobile */}
        <button
          className={homeStyles.hamburger}
          aria-label="Otwórz menu"
          onClick={() => setMenuOpen(true)}
        >
          <span />
          <span />
          <span />
        </button>
        {/* Mobile overlay menu */}
        {menuOpen && (
          <div className={homeStyles.menuOverlay} onClick={handleMenuClose}>
            <nav
              className={homeStyles.mobileMenu}
              onClick={e => e.stopPropagation()}
            >
              <button
                className={homeStyles.closeMenu}
                aria-label="Zamknij menu"
                onClick={handleMenuClose}
              >
                &times;
              </button>
              <a href="/o-nas" className={homeStyles.navLink} onClick={handleMenuClose}>O nas</a>
              <a href="/uslugi" className={homeStyles.navLink} onClick={handleMenuClose}>Usługi</a>
              <a href="/case-study" className={homeStyles.navLink} onClick={handleMenuClose}>Case Study</a>
              <a href="/webinary" className={homeStyles.navLink} onClick={handleMenuClose}>Webinary</a>
              <a href="/baza-wiedzy" className={homeStyles.navLink} onClick={handleMenuClose}>Baza wiedzy</a>
              <a href="/kontakt" className={homeStyles.ctaBtn} onClick={handleMenuClose}>Bezpłatna konsultacja</a>
            </nav>
          </div>
        )}
      </header>

      {/* CONTACT HERO + FORM */}
      <div className={styles.contactPageRoot}>
        {/* BLOKADA FORMULARZA KONTAKTOWEGO - USUŃ TEN BLOK, ABY PRZYWRÓCIĆ FORMULARZ */}
        <div className={styles.contactComingSoon}>
          <h2>Kontakt będzie dostępny wkrótce</h2>
          <p>Pracujemy nad uruchomieniem formularza kontaktowego. Wkrótce będzie można się z nami skontaktować bezpośrednio przez stronę.</p>
          <p>W międzyczasie napisz do nas na <a href="mailto:kontakt@paperly.io">kontakt@paperly.io</a></p>
        </div>
        {/* KONIEC BLOKADY */}
        {/*
        <div className={styles.contactHero}>
          <div className={styles.contactLeft}>
            <h1 className={styles.contactTitle}>Porozmawiajmy o automatyzacji<br />w Twojej firmie</h1>
            <p className={styles.contactDesc}><span className={styles.contactHighlight}>Bezpłatna konsultacja</span> to 30 minut, w trakcie których omawiamy Twoje cele biznesowe i sprawdzamy, czy automatyzacja dokumentów może pomóc w ich realizacji.</p>
            <ul className={styles.contactList}>
              <li>Dowiesz się, jak automatyzacja dokumentów oszczędza czas i pieniądze</li>
              <li>Odpowiemy na wszystkie pytania o AI i automatyzację</li>
              <li>Pokażemy przykłady wdrożeń w biurach i administracji</li>
            </ul>
          </div>
          <div className={styles.contactRight}>
            <form className={styles.contactForm} onSubmit={e => { e.preventDefault(); }}>
              <input className={styles.contactInput} type="email" placeholder="Podaj adres email*" required />
              <input className={styles.contactInput} type="tel" placeholder="Podaj numer telefonu*" required />
              <input className={styles.contactInput} type="text" placeholder="Napisz temat rozmowy*" required />
              <div className={styles.contactCheckboxRow}>
                <input
                  type="checkbox"
                  id="consent-contact"
                  required
                  className={styles.contactCheckbox}
                />
                <label htmlFor="consent-contact" className={styles.contactCheckboxLabel}>
                  Wyrażam zgodę na kontakt telefoniczny i e-mailowy w celu obsługi niniejszego zgłoszenia, zgodnie z{' '}
                  <a href="/polityka-prywatnosci" target="_blank" rel="noopener noreferrer">
                    Polityką prywatności
                  </a>
                  .*
                </label>
              </div>
              <div className={styles.contactCheckboxRow}>
                <input
                  type="checkbox"
                  id="consent-marketing"
                  className={styles.contactCheckbox}
                />
                <label htmlFor="consent-marketing" className={styles.contactCheckboxLabel}>
                  Wyrażam zgodę na otrzymywanie informacji handlowych drogą elektroniczną (np. newsletter, oferty), zgodnie z{' '}
                  <a href="/polityka-prywatnosci" target="_blank" rel="noopener noreferrer">
                    Polityką prywatności
                  </a>
                  .
                </label>
              </div>
              <button type="submit" className={homeStyles.heroBtnPrimary + ' ' + styles.contactBtnBlue}>Wyślij wiadomość</button>
            </form>
          </div>
        </div>
        <div className={styles.contactTeamSection}>
          <div className={styles.contactTeamPhoto}>
            {/* Podmień na swoje zdjęcie zespołu */}
            {/* <img src="/team-placeholder.png" alt="Zespół Paperly" />
          </div>
          <div className={styles.contactTeamText}>
            <p>Jesteśmy tu, aby pomóc Ci w rozwoju Twojej firmy. Znamy wyzwania biur, administracji i księgowości – dlatego wyciągamy pomocną dłoń do każdego, kto chce zautomatyzować dokumenty i procesy.</p>
            <p>Na każdym kroku staramy się zrozumieć Twoje potrzeby i odpowiadamy na nie w przemyślany, ludzki sposób.</p>
          </div>
        </div>
         */}
      </div>

      {/* FOOTER */}
      <footer className={homeStyles.footer}>
        <div className={homeStyles.footerBottom}>
          &copy; {new Date().getFullYear()} Paperly. Wszelkie prawa zastrzeżone. Made with ❤️ in Poland
        </div>
      </footer>
    </div>
  );
} 